import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import { HashRouter as Router} from 'react-router-dom'
import createHistory from 'history/createBrowserHistory'

import './index.scss'
import App from './App'
import registerServiceWorker from './registerServiceWorker'

import store from 'store'
import http from 'store/actions'

const history = createHistory()
http.setup(store,history)

ReactDOM.render(
  <Provider store={store}>
    <Router><App /></Router>
  </Provider>, document.getElementById('root')
)
if(process.env.NODE_ENV === 'production'){
  registerServiceWorker()
}




// WEBPACK FOOTER //
// ./src/index.js